<template>
  <mds-list-group-item v-if="showSingleLink"
    :text="titleText"
    :active="isSingleLinkActive"
    @click.native="itemClicked"
  >
  </mds-list-group-item>
  <mds-list-group-item
    v-else
    has-collapsible-child
    :collapsible="true"
    :expanded="toggleActive"
    :text="titleText"
    @click.native="subListClicked"
  >
    <template #mds-list-item-children>
      <nav-single-item
        v-for="sub in itemSublist"
        :text="sub.text"
        :baseRoute="routeString"
        :key="sub.text"
      />
    </template>
  </mds-list-group-item>
</template>

<script>
import { MdsListGroupItem } from '@mds/list-group';
import NavItemMixin from './nav-item-mixin';
import NavSingleItem from './nav-single-item.vue';
import RouteProcessor from '../../utils/route-processor.js';
import { CONTENT_TYPE, REGION } from '../../data/constants';

export default {
  name: 'nav-sublist',
  components: {
    MdsListGroupItem,
    NavSingleItem,
  },
  mixins: [NavItemMixin],
  props: {
    baseRoute: String,
    contentType: String, // This is the path base, e.g. 'components' or 'apis' - required
    itemSublist: Array,
    section: String,
  },
  computed: {
    showSingleLink() {
      return [CONTENT_TYPE.APIS, CONTENT_TYPE.COMPONENTS].indexOf(this.contentType) > -1 || this.itemSublist.length === 1;
    },
    isSingleLinkActive() {
      return this.showSingleLink && this.$route.path.includes(this.baseRouteUrl + '/');
    },
    baseRouteUrl() {
      if (this.region && this.region !== REGION.ALL) {
        return this.baseRoute;
      }
      return `${this.baseRoute}/${RouteProcessor.getAlias(this.text)}`;
    },
    firstSubListItemRouteString() {
      return `${this.baseRouteUrl}/${RouteProcessor.getAlias(this.itemSublist[0].text)}`;
    },
    routeString() {
      if (this.showSingleLink) {
        return this.firstSubListItemRouteString;
      }
      // It would be more performant to create this once on created(), but created()
      // doesn't get called when the nav data changes, but the same item type is in
      // the same place in the new nav data. But the props do change. So it's either
      // generate the route string dynamically on demand, or watch the props.
      return this.baseRouteUrl;
    },
    toggleActive() {
      return this.$route.path.startsWith(this.routeString);
    },
  },
  methods: {
    itemClicked() {
      this.$router.push({ path: this.routeString });
    },
    subListClicked(event) {
      if (event.target.closest('li') === event.currentTarget) {
        window.setTimeout(() => {
          this.$router.push({ path: this.firstSubListItemRouteString });
        });
      }
    },
  },
}
</script>
